// extracted by mini-css-extract-plugin
module.exports = {"panelContainer":"CanvasObjectPropertyViewer_panelContainer__1plvs","division_line":"CanvasObjectPropertyViewer_division_line__3HyCR"};